import { ReactElement } from 'react'
import { defaultTheme } from '../../../../../src/theme/index'
import { Button } from '../../../../../src/ui-components/forms/Button'
import styled from 'styled-components'
import CrossReferenceIcon from 'src/assets/icons/CrossReferenceIcon.svg'
import { useNavigate } from 'react-router-dom'
import { Translate, Translate2 } from 'common'
import { Tooltip } from '../../../../../src/ui-components/util/MUITooltipCustomization'

interface Props {
  partNumber: string
}

const CrossReferenceButton = (props: Props): ReactElement => {
  const { partNumber } = props
  const navigate = useNavigate()

  const goToCrossReferenceResults = (): void => {
    navigate(`/cross-reference?partNumber=${partNumber}`)
  }

  const msg = Translate('crossReferenceTooltipMsg', [partNumber])

  const info = <Info>{msg}</Info>

  const Icon = (
    <img
      src={CrossReferenceIcon}
      alt={Translate2('crossReferenceIcon')}
      style={{ margin: '-4px 4px 0px 0px' }}
    />
  )

  return (
    <Tooltip title={info} placement="top" arrow>
      <div>
        <CrossFerenceBtn
          icon={Icon}
          text="crossReference"
          onClick={goToCrossReferenceResults}
        />
      </div>
    </Tooltip>
  )
}

const CrossFerenceBtn = styled(Button)`
  background: ${defaultTheme.colors.blueLight};
  color: white;
  font-size: 13px;
  line-height: 20px;
  height: 32px;
  width: 168px;
`

const Info = styled.div`
  font-size: 14px;
  max-width: 168px;
  height: auto;
`

export default CrossReferenceButton
